import styled from '@emotion/styled';

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
